import React, { FC } from 'react'

import { DemoPopup } from 'pages/soundscape-page/components/DemoPopup'

import bg from './assets/prime-bg.jpg'
import mobileBg from './assets/prime-bg-mobile.jpg'

import type { SoundscapeDemoPopupContent } from 'redux/popupReducer'

interface SoundscapePrimeProps {
  content: SoundscapeDemoPopupContent
}

export const SoundscapePrime: FC<SoundscapePrimeProps> = ({ content }) => {
  return (
    <DemoPopup
      backgroundImage={bg}
      mobileBackgroundImage={mobileBg}
      logo={content.logoUrl}
      title={content.title}
      description={content.description}
    />
  )
}
